import { AppBar, Toolbar, Box, Grid, IconButton, Avatar, Menu, MenuItem, Button, ListItemText } from '@mui/material';
import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export function Header() {
    const { isAuthenticated, isLoading, user, loginWithRedirect, logout } = useAuth0();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    function handleLogout() {
        setAnchorEl(null);
        logout({ logoutParams: { returnTo: window.location.origin } });
    }

    return (
        <Box>
            <AppBar position='sticky'>
                <Toolbar>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={8}>
                            <Box component='img' src='/images/headerLogo.png' alt='' sx={{ maxWidth: '100%', height: 'auto', display: 'block' }} />
                        </Grid>
                        <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {!isLoading && (
                                isAuthenticated ? (
                                    <>
                                        <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} sx={{ p: 0 }}>
                                            <Avatar src={user?.picture} alt={user?.name ?? 'Account'} sx={{ width: 36, height: 36 }} />
                                        </IconButton>
                                        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                                            <MenuItem disabled>
                                                <ListItemText primary={user?.name} secondary={user?.email} />
                                            </MenuItem>
                                            <MenuItem onClick={handleLogout}>Sign Out</MenuItem>
                                        </Menu>
                                    </>
                                ) : (
                                    <Button color='inherit' variant='outlined' onClick={() => loginWithRedirect()}>
                                        Sign In
                                    </Button>
                                )
                            )}
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
        </Box>
    );
}
